import Keycloak from "keycloak-js";

interface LogoutProps {
    keycloak: Keycloak
}

export function Logout(props: LogoutProps) {
    props.keycloak.logout({ redirectUri: window.location.protocol + '//' + window.location.host + "/" });
    return <></>;
}